import { EventBroker } from "@frontend/lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT',
  SAVE: 'SAVE',
  CANCEL: 'CANCEL',
};

export const brandColorsEventBroker = new EventBroker();
